import pick from 'lodash/pick';
import type { LogsEvent } from '@datadog/browser-logs';

const MAX_EVENTS_COUNT = 100;
const MAX_MESSAGE_LENGTH = 1000;

// TODO: Consider localStorage
let logsEvents: LogsEvent[] = [];

export const addConsoleDumpLogsEvent = (logsEvent: LogsEvent) => {
  // Datadog declares message as required property but it might happen that it is actually undefined
  let message = logsEvent.message ? logsEvent.message : 'unused';

  message =
    message.length > MAX_MESSAGE_LENGTH
      ? message.substring(0, MAX_MESSAGE_LENGTH) + '…'
      : message;

  logsEvents.push({ ...logsEvent, message });
  logsEvents = logsEvents.slice(-MAX_EVENTS_COUNT);
};

export const getConsoleDump = (
  newestOnTop: boolean,
  pickedProperties: (keyof LogsEvent)[],
  messageExclude?: RegExp
) => {
  const events = newestOnTop ? logsEvents.toReversed() : [...logsEvents];
  const eventsWithReadableDate = events.map(e => ({
    ...e,
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- contrary to types date might be missing
    date: e.date !== undefined ? new Date(e.date).toISOString() : undefined,
  }));

  const filteredEvents = messageExclude
    ? eventsWithReadableDate.filter(
        e => !e.message || !messageExclude.test(e.message)
      )
    : eventsWithReadableDate;

  if (pickedProperties.length === 0) {
    return filteredEvents;
  }

  return filteredEvents.map(e => pick(e, pickedProperties));
};
